(function () {
  'use strict';

  /* @ngdoc object
   * @name etsReport
   * @description
   *
   */
  angular
    .module('etsReport', [
      'ui.router'
    ]);
}());
